export default __webpack_public_path__ + "static/media/illustration-what-is-milluu.4b1b9fab.svg";